class ScrollToService {
    scroll(target) {
        if(target) {
            $('body,html').animate({scrollTop: target.offsetTop - 90}, "slow");
        }
    }
}
commons.service('scrollToService', ScrollToService);